@if (layoutService.nameComponents) {
  <span
    class="alert alert-info"
  >mydayeventlist.component.html</span>
}
<ul class="list-group list-group-flush ">
  @for (ev of dayEvents; track ev) {
    <li
    [ngStyle]="{
      'borderRightColor':layoutService.activeColor.backgroundColor,
      'border':'100px sold red !important '
      }"
      [routerLinkActiveOptions]="{exact: false}"
      [routerLink]="['/',viewForRole,'documentview',ev.day, ev._id]"
      class="list-group-item"
      routerLinkActive="activeTime"
      style="background-color: #F2F2F5"
      >
      <div class="row">
        <div class="col-12  col-lg-3 pl-0">
          @if (userTimezone) {
            <small>{{ev.start | timezone: this.startDate : ev.day : this.userTimezone :
            this.packTimezone : true}}</small>
          }
          @if (!userTimezone) {
            <small>{{ev.start}}</small>
          }
          <br>
            <small>
              @if (ev.roomLink &&  ev.roomName &&ev.roomLink.trim() !='' && ev.roomName.trim() !='' && ev.roomLink.trim() != '-') {
                <a
                  href="{{ev.roomLink}}"
                  target="_blank"
                  [style.color]="layoutService.activeColor.backgroundColor"
                  ><u>{{ev.roomName}}</u></a>
                }
                @if (!ev.roomLink  || ev.roomLink.trim() == '' || ev.roomLink.trim() == '-') {
                  <span> {{ev.roomName}}</span>
                }
              </small>
            </div>
            <div class="col pl-0 pl-xs-3">
              {{ev.timeblock.name}}
              <br>
                @for (participant of ev.participants; track participant; let i = $index) {
                  <span>@if (viewForRole === 'observer') {
                    <span
                    >{{participant.fullNameWithIndex}}</span>
                    }@if (viewForRole !== 'observer') {
                    <span
                    >{{participant.firstname}} {{participant.lastname}}</span>
                  }
                  @if ((i +1) != ev.participants.length) {
                    <span>, </span>
                  }</span>
                }
              </div>
            </div>
          </li>
        }
      </ul>